import type {ReactNode} from 'react';
import React from 'react';

import CSSModules from 'react-css-modules';

import styles from './styles.module.scss';

type HoverableIconProps = {
  hoverIcon: string | ReactNode;
  noHoverIcon: string | ReactNode;
  isHovered?: boolean;
};

//Provides an icon that changes colour when hovered. Assumes both icons are the same size.
const HoverableIcon = ({
  hoverIcon,
  noHoverIcon,
  isHovered,
}: HoverableIconProps): JSX.Element => {
  const getIconComponent = (icon: string | ReactNode, styleName: string) =>
    typeof icon === 'string' ? (
      <img styleName={styleName} src={icon} />
    ) : (
      <div styleName={styleName}>{icon}</div>
    );

  const spacerIcon = getIconComponent(noHoverIcon, 'spacerIcon');
  const icon = getIconComponent(noHoverIcon, 'icon');
  const hoverIconToRender = getIconComponent(hoverIcon, 'hoveredIcon');

  return (
    <div styleName={`container ${isHovered ? 'forceHovered' : ''}`}>
      {/*assumes both icons are the same size*/}
      {spacerIcon}
      {icon}
      {hoverIconToRender}
    </div>
  );
};

export default CSSModules(HoverableIcon, styles, {allowMultiple: true});
